import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useDispatch, useSelector } from 'react-redux'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import PropagateLoader from "react-spinners/PropagateLoader"
import { useFormik } from 'formik'
import { AddAttendanceSchema } from './CourseManagementSchema'
import { addAttendanceRes, addAttendanceTodo } from '../../LMS_Redux/LMS_Slices/Course/AddAttendance'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

export default function AddAttendance(props) {

    const { attendModal, setAttendModal, attendData, setAttendData, modalLoading, setModalLoading, bool, setBool } = props
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [spinner, setSpinner] = useState(false)
    const training_user = useSelector(state => state.attendanceUserList && state.attendanceUserList.data && state.attendanceUserList.data.data)
    // console.log(attendData)

    const initialValues = {
        training_id: attendData && attendData.id,
        attend_user: [],
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: AddAttendanceSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addAttendanceTodo(values)).then(() => add_res(action))
        },
    })

    const add_res = (action) => {

        if (addAttendanceRes && addAttendanceRes.success) {

            action.resetForm()
            setBool(!bool)
            setAttendModal(false)
            setAttendData()
            toast.success(addAttendanceRes.message, { position: "bottom-right" })
            setTimeout(() => {
                setSpinner(false)
                navigate('/training_list')
            }, 1200);

        } else {
            toast.error(addAttendanceRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'vemp_fname',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 300
        },
        {
            headerName: 'ID',
            field: 'vemp_company_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'vdepartment_name',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'DESIGNATION',
            field: 'vdesignation_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMAIL',
            field: 'vemail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PHONE NO.',
            field: 'vmobile_no',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ]);

    const handleClose = () => {
        setAttendModal(false)
        setAttendData()
    }

    return (
        <>
            <Modal
                show={attendModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Attendance ({attendData && attendData.training_title})</Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                    <Modal.Body>
                        {modalLoading ?
                            <div className='text-center mb-3'>
                                <PropagateLoader
                                    color="#2262C6"
                                    size={20}
                                />
                            </div>
                            :
                            <>
                                <DataTables
                                    rowData={training_user}
                                    columnDefs={columnDefs}
                                    selection={true}
                                    value={setFieldValue}
                                    field={"attend_user"}
                                    check={"multiple"}
                                    // preSelected={test ? test : ''}
                                    addAttendanceCheck={true}
                                    height={'40vh'}
                                    id={'page-size1'}
                                />
                                {errors.attend_user && touched.attend_user ? (<span className='text-danger form_label'>{errors.attend_user}</span>) : null}
                            </>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='btn btn_submit' variant="primary" type='submit' disabled={spinner ? true : false}>Submit  {spinner ?
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='ms-2'
                            />
                            : ''
                        }</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}
